import { string, object, number, date } from 'yup';
import { CONSTANTS } from '../constants';
export const customerAssignmentDetailsValidation = object().shape({
  fullNameFromContractor: string().nullable(),
  siteId: number().nullable(),
  lockerNumber: string().nullable(),
  voucherExpiry: date().when(['proDuration', 'mailBoxDuration'], {
    is: (proDuration: number | null, mailBoxDuration: number | null) => proDuration || mailBoxDuration,
    then: (schema) => schema.required(CONSTANTS.VALIDATION_ERRORS.REQUIRED),
    otherwise: (schema) => schema.nullable(),
  }),
  proDuration: number().nullable(),
  mailBoxDuration: number().nullable(),
});
